let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("79tkO")).then(() => parcelRequire('5qJDK'));